<script>
    export let tier_name = "";
    export let tier_originator_id = "";
    export let tier_business_channel_id = "";
    export let tier_tier_id = Math.floor(
      10000000 + Math.random() * 90000000
    ).toString();
  
    export let cancelHandler;
    export let saveHandler;
  
    setTimeout(()=>{
      console.log(`Generated tier_tier_id is ${tier_tier_id}`);
    }, 1000);
  
  </script>
  
  <div  class="w-full mt-4 pl-8">
    <!-- <div>
          <label for="email" class=" text-sm text-gray-800">Name</label>
          <input bind:value={name} type="email"
              class=" w-1/2 px-4 py-2 mt-2 text-red-700 bg-white border rounded-md focus:border-red-400 focus:ring-red-300 focus:outline-none focus:ring focus:ring-opacity-40">
          <label for="email" class="text-sm text-gray-800">Email</label>
          <input bind:value={email} type="email"
              class=" w-1/2 px-4 py-2 mt-2 text-red-700 bg-white border rounded-md focus:border-red-400 focus:ring-red-300 focus:outline-none focus:ring focus:ring-opacity-40">
      </div> -->
  
    <form class="w-full max-w-lg">
      <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-first-name"
          >
            Name
          </label>
          <input
            bind:value={tier_name}
            class="appearance-none block w-full bg-gray-200 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            id="grid-first-name"
            type="text"
            placeholder="Tier Name"
          />
          <!-- <p class="text-red-500 text-xs italic">Please fill out this field.</p> -->
        </div>
        <div class="w-full md:w-1/2 px-3">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-last-name"
          >
            Tier Originator ID
          </label>
          <input
            bind:value={tier_originator_id}
            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="grid-last-name"
            type="text"
            placeholder="0000000"
          />
        </div>
        <div class="w-full md:w-1/2 px-3">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="grid-last-name"
          >
            Tier Business Channel ID
          </label>
          <input
            bind:value={tier_business_channel_id}
            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="grid-last-name"
            type="text"
            placeholder="0000000"
          />
        </div>
      </div>
  
  
  
      <div class="flex flex-wrap -mx-3 mb-6">
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <button on:click|preventDefault={saveHandler} class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                  Save Tier
                </button>
  
          </div>
          <div class="w-full md:w-1/2 px-3">
              <button on:click|preventDefault={cancelHandler} class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
                  Cancel
                </button>
          </div>      
        </div>
    
    
  
    </form>
  </div>
  